wbApp.controller('PasswordResetCtrl', ['$scope', 'securitySvc', '$window', '$translate', '$interval',
    function ($scope, securitySvc, $window, $translate, $interval) {
    $scope.model = $scope.model || {
        email: null,
        password: null,
        otp: null
    };
    
    $scope.authCodeWasSend = false;
    $scope.authCodeSending = false;
    $scope.passwordValidationRegEx = securitySvc.passwordValidationRegEx();
    
    $scope.onAuthCodeResend = function() {
        if ($scope.authCodeSending) {
            return;
        }
        if ($scope.form.loginForm_emailInput_textField.$valid) {
            $scope.authCodeSending = true;
            $scope.detailError = null;
            
            securitySvc.sendPasswordResetAuthorizationCode($scope.model.email).then(
                function(success) {
                    $scope.authCodeSending = false;
                    $scope.authCodeWasSend = true;
                },
                function(error) {
                    $scope.authCodeSending = false;
                    if (!!error && !!error.title) {
                        if (error.title.includes("EMAIL_NOT_FOUND")) {
                            $scope.detailError = $translate.instant('TXT_LOGIN_ERROR_USER_NOT_FOUND');
                        } else if (error.title.includes('INVALID_EMAIL')) {
                            $scope.detailError = $translate.instant('TXT_LOGIN_ERROR_INVALID_EMAIL');
                        } else {
                            $scope.detailError = error.title;
                        }
                    } else {
                        $scope.detailError = $translate.instant('TXT_OTP_GENERATE_BUSY');
                    }
                });
        }
    }
    
    $scope.onPasswordSet = function(model) {
        if ($scope.isSaving) {
            return;
        } 
        $scope.isSaving = true;
        securitySvc.confirmPasswordReset(model.email, model.password, model.otp).then(
            function() {
                securitySvc.signIn(model.email, model.password).then(
                    function (success) {
                        $scope.isSaving = false;
                        $window.location.reload();
                    },
                    function (error) {
                        $scope.isSaving = false;
                        if (!error) {
                            $scope.detailError = $translate.instant('TXT_SIGN_IN_FAILED');
                        } else {
                            $scope.detailError = securitySvc.gcpErrorCodeToText(error);
                        }
                    });                
            },
            function(error) {
                console.error(error);
                $scope.isSaving = false;
                if (!error) {
                    $scope.detailError = $translate.instant('TXT_OTP_VERIFY_BUSY');
                } else {
                    if (!!error.title && error.title.includes("One time password does not exist or is expired.")) {
                        $scope.detailError = $translate.instant('TXT_OTP_DOES_NOT_EXIST');
                    } else {
                        $scope.detailError =error.title;
                    }
                }
                
            }
        );
    }
}]);